import { TGeocodedAddress } from '../types';

export const formatGeocodedAddress = ({ city, country, addressNumber, postCode, street }: TGeocodedAddress): string => {
    // feature type is address
    if (addressNumber && postCode && street) {
        return `${street} ${addressNumber}, ${city} ${postCode}, ${country}`;
    }
    // feature type is street
    if (street && postCode) {
        return `${street}, ${city} ${postCode}, ${country}`;
    }
    // feature type is place
    return `${city}, ${country}`;
};
